import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/404.svg")